<div class="row">
    <div class="col-md-12 col-lg-12 col-12 pr-0">
        <globalafiliados></globalafiliados>
    </div>
</div>
<div class="row">
    <div class="col-md-12 col-lg-4 col-12 pr-0">
        <globalciudades></globalciudades>
    </div>
    <div class="col-md-12 col-lg-4 col-12 pr-0">
        <globalnuevosinactivos></globalnuevosinactivos>
    </div>
    <div class="col-md-12 col-lg-4 col-12 pr-0">
        <globalafiliadosporfatolio></globalafiliadosporfatolio>
    </div>
</div>
<div class="row mt-3 mb-5">
    <div class="col-md-6 col-12 pr-0">
        <globalasesores></globalasesores>
    </div>
    <div class="col-md-6 col-12 pr-0">
        <globalventas></globalventas>
    </div>
</div>